<template>
  <b-modal
    ref="secretKeyModal"
    modal-class="settings-modal"
    centered
    hide-header-close
    title="Webhook details"
    size="sm"
    @hidden="reset" >
    <div>
      <b-form-group>
        <label
          for="p-key"
          class="settings__label" >
          Url
        </label>
        <CopyInput :value="webhook.url"/>
      </b-form-group>

      <b-form-group>
        <label
          for="p-key"
          class="settings__label" >
          Secret key
        </label>
        <CopyInput :value="webhook.secret_key"/>
      </b-form-group>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import CopyInput from '@/components/common/CopyInput';

export default {
  name: 'SecretKeyModal',
  components: {
    CopyInput,
  },
  data() {
    return {
      webhook: {},
    };
  },
  methods: {
    show(webhook) {
      this.webhook = webhook;
      this.$refs.secretKeyModal.show();
    },
    hide() {
      this.$refs.secretKeyModal.hide();
    },
    reset() {
      this.webhook = {};
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep label.settings__label {
  margin-top: 0 !important;
}
</style>
